import ApiResponse from "./ApiResponse";

export default class ApiErrorResponse extends ApiResponse{

  constructor(code, message, data) {
    super(message, data)
    this.code = code;
  }

}